import BankingPage from "./BankingPage";

export default BankingPage;
